import { render, staticRenderFns } from "./teamRYDetail.vue?vue&type=template&id=ab99b8a8&scoped=true"
import script from "./teamRYDetail.vue?vue&type=script&lang=js"
export * from "./teamRYDetail.vue?vue&type=script&lang=js"
import style0 from "./teamRYDetail.vue?vue&type=style&index=0&id=ab99b8a8&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./teamRYDetail.vue?vue&type=style&index=1&id=ab99b8a8&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab99b8a8",
  null
  
)

export default component.exports